const ENV = process.env.REACT_APP_ENV || 'development';
if (ENV != 'prod') {
  console.log('#####config_ENV:', ENV);
}
module.exports = require('./' + ENV + '.js');
